import { Button, Text, Img } from "./..";
import React from "react";
import { Link, useLocation } from "react-router-dom";

interface Props {
  className?: string;
}

export default function Header({ ...props }: Props) {
  const location = useLocation();

  const menuItems = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about-us" },
    { name: "Services", href: "/service" },
    { name: "Contact Us", href: "/contact-us" },
    { name: "Career", href: "/career" },
  ];

  return (
    <header
      {...props}
      className={`${props.className} flex justify-between items-start gap-5`}
    >
      <div className="cursor-pointer">
        <Link to="/">
          <Img
            src="images/site95.png"
            alt="Header Logo"
            className="mt-1.5 h-[48px] w-[222px] sm:h-[40px] sm:w-[180px] md:h-[32px] md:w-[110px] object-contain"
          />
        </Link>
      </div>
      <ul className="flex items-start gap-10 md:gap-4 self-end sm:flex-col sm:self-auto">
        {menuItems.map((item) => (
          <li key={item.href}>
            <Link to={item.href} className="cursor-pointer lg:text-[20px]">
              <div className="flex flex-col items-start gap-2 sm:gap-3 md:gap-4 lg:gap-2.5">
                <Text
                  size="texts"
                  as="p"
                  className={`text-[20px] sm:text-[22px] md:text-[16px] lg:text-[20px] font-medium uppercase ${
                    location.pathname === item.href
                      ? "text-red-a200"
                      : "text-black-900"
                  } hover:font-medium hover:text-red-a200`}
                >
                  {item.name}
                </Text>
                {location.pathname === item.href && (
                  <div className="h-[3px] w-[42px] bg-red-a200" />
                )}
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <Link to="/sign-up">
        <Button
          shape="round"
          className="sm:min-w-[160px] md:min-w-[30px] self-center rounded-[10px] !border-2 px-6 md:px-[1] sm:px-6 md:text-[16px]"
        >
          Register
        </Button>
      </Link>
    </header>
  );
}
